<template>
    <StickyContainer
        v-resize.immediate="onResize"
        class="company-header-menu"
        :offset="topBarHeight - 1"
    >
        <ul class="menu w-full flex flex-row flex-nowrap items-start overflow-x-auto">
            <li
                v-if="showAboutUsSection"
                class="mr-6 flex flex-none"
            >
                <a
                    class="text-blue-600 cursor-pointer"
                    :data-click="`company profile menu,about us`"
                    href="#about"
                    v-text="t('show.section_about_us')"
                ></a>
            </li>
            <li
                v-if="showCareerSection"
                class="mr-6 flex flex-none"
            >
                <a
                    class="text-blue-600 cursor-pointer"
                    :data-click="`company profile menu,career`"
                    href="#career"
                    v-text="t('show.section_career')"
                ></a>
            </li>
            <li
                v-if="showArticlesSection"
                class="mr-6 flex flex-none"
            >
                <a
                    class="text-blue-600 cursor-pointer"
                    :data-click="`company profile menu,news & events`"
                    href="#articles"
                    v-text="t('show.section_articles')"
                ></a>
            </li>
            <li
                v-if="showVideosSection"
                class="mr-6 flex flex-none"
            >
                <a
                    class="text-blue-600 cursor-pointer"
                    :data-click="`company profile menu,videos`"
                    href="#videos"
                    v-text="t('show.section_videos')"
                ></a>
            </li>
            <li
                v-if="isLoggedIn"
                class="ml-auto"
            >
                <BtnMenu
                    size="xs"
                    left-icon="more"
                    :options="menuItems"
                    menu-placement="bottom-end"
                />
            </li>
        </ul>
    </StickyContainer>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import StickyContainer from '@/components/StickyContainer';
import { initializeClickListeningToTrack } from '@/modules/tracking';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'CompanyShowHeaderMenu',

    components: {
        StickyContainer,
    },

    setup() {
        const { t } = useTranslation(['company', 'dsa']);
        return { t };
    },

    data() {
        return {
            headers: [
                'about',
                'career',
                'articles',
                'videos',
            ],
            reported: false,
            height: 0,
            removeClickListener: null,
        };
    },

    computed: {
        ...mapGetters({
            company: 'company/currentCompany',
            showIntroSection: 'company/showIntroSection',
            showAboutUsSection: 'company/showAboutUsSection',
            showCareerSection: 'company/showCareerSection',
            showArticlesSection: 'company/showArticlesSection',
            showVideosSection: 'company/showVideosSection',
            topBarHeight: 'ui/topBarHeight',
            isLoggedIn: 'auth/isLoggedIn',
        }),
        reportedLabel() {
            return this.reported ? this.t('menu.reported') : this.t('menu.report');
        },
        menuItems() {
            return [
                {
                    icon: 'flag',
                    label: this.reportedLabel,
                    onClick: this.emitReportDsa,
                    class: this.reported ? 'text-red-400 pointer-events-none cursor-default' : '',
                },
            ];
        },
    },
    watch: {
        height(val) {
            this.$store.dispatch('ui/setPageTopOffset', val - 1);
        },
    },

    beforeUnmount() {
        this.$store.dispatch('ui/resetPageTopOffset');
        this.removeClickListener();
    },

    mounted() {
        this.removeClickListener = initializeClickListeningToTrack(this.$el, 'CompanyPage', {
            company_id: this.company.id,
        });
    },

    methods: {
        onResize(el) {
            this.height = el.offsetHeight;
        },
        emitReportDsa() {
            const res = this.$modal.open(
                defineAsyncComponent(() => import('@/components/ModalReportDsa')),
                {
                    reportData: {
                        reported_item_id: this.company.id,
                        reported_item_type_id: 3,
                    },
                },
            );
            res?.then((reported) => {
                this.reported = reported ?? false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.company-header-menu {
    &.is-sticky {
        @apply py-4 z-[19] border-t border-solid bg-white shadow;

        .menu {
            @apply container;
        }
    }

    &:not(.is-sticky) {
        @apply md:container;
        .menu {
            @apply max-md:container py-5 md:px-4 md:rounded-b-lg bg-white shadow;
        }
    }
}
</style>
